/*
  Reveal on scroll (Theme settings › Animations › Sections). A section that is below the window when
  the page opens waits unseen, and its content rises in once, the first time the section comes into view; the look is
  in assets/base.css. Only this script marks a section, so nothing else is ever hidden: not what shows as the page
  opens, nothing for a shopper who asks for less motion, and nothing drawn later (a section the theme editor reloads,
  a Section Rendering answer, more products), which shows as it arrives.
*/
if (!customElements.get('scroll-reveal')) {
  // Every section of the page: a template section's frame (snippets/section-frame.liquid) and the footer.
  const SECTIONS = '.section-frame, .footer';

  class ScrollReveal extends HTMLElement {
    connectedCallback() {
      if (lessMotion.matches) return;
      // A section rises once its first 50 px are in the window, so the shopper sees it come up.
      this.observer = new IntersectionObserver((entries) => entries.forEach((entry) => this.update(entry)), {
        rootMargin: '0px 0px -50px 0px',
      });
      document.querySelectorAll(SECTIONS).forEach((section) => this.observer.observe(section));
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    // The first report says where a section starts: below the window, it waits; anywhere else (on screen, above it,
    // hidden) it is left alone. A section that waits rises when it comes in, and loses its mark once its content stands.
    update({ target: section, isIntersecting, boundingClientRect }) {
      if (!isIntersecting && boundingClientRect.top >= window.innerHeight) {
        section.dataset.reveal = 'wait';
        return;
      }
      this.observer.unobserve(section);
      if (section.dataset.reveal !== 'wait') return;
      section.addEventListener('animationend', function risen(event) {
        if (event.target.parentElement !== section) return;
        section.removeEventListener('animationend', risen);
        delete section.dataset.reveal;
      });
      section.dataset.reveal = 'in';
    }
  }

  customElements.define('scroll-reveal', ScrollReveal);
}
